export default __webpack_public_path__ + "static/media/WERS_Volunteer_Application_Form.f6b3077d.rtf";